<template>
    <div>
        <b-card class="standardpage border-none">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="travellerprofiles.icon" class="mr-1"></i>
                        <span>{{ travellerprofiles.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-show="!component" class="availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0">
                        <b-row v-if="!showfilter">
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                                    <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..."
                                        v-model="slac" :clearable="true" :multiple="true" :async="true"
                                        :load-options="treeselect_loadSLAC" :show-count="true"
                                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                        search-nested>
                                        <div slot="value-label" slot-scope="{ node }">
                                            {{ node.raw.id }}
                                        </div>
                                    </treeselect>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Traveller" label-size="sm">
                                    <b-input-group>
                                        <b-form-tags input-id="reflist2" v-model="traveller" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste Travellers" size="sm" class="h-29"
                                            add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>
                                        <!-- <b-form-input v-model="traveller" :debounce="travellerprofiles.debounce"
                                            placeholder="Traveller" trim></b-form-input> -->
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!traveller"
                                                @click="traveller = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="EmployeeNo" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="employeeno" :debounce="travellerprofiles.debounce"
                                            placeholder="EmployeeNo"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!employeeno"
                                                @click="employeeno = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Email?" label-size="sm">
                                    <b-input-group class="treeselect_all justify-content-end pr-2px">
                                        <b-form-checkbox-group id="emailempty" v-model="emailempty"
                                            :options="options_emailempty" size="sm" value-field="id" text-field="label"
                                            name="radio-options" class="z-0" style="padding-top: 0.2em">
                                        </b-form-checkbox-group>
                                    </b-input-group>
                                    <b-input-group>
                                        <b-form-input v-model="email" :debounce="travellerprofiles.debounce"
                                            placeholder="Email" trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!email"
                                                @click="email = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Phone?" label-size="sm">
                                    <b-input-group class="treeselect_all justify-content-end pr-2px">
                                        <b-form-checkbox-group id="mobileempty" v-model="mobileempty"
                                            :options="options_mobileempty" size="sm" value-field="id" text-field="label"
                                            name="radio-options" class="z-0" style="padding-top: 0.2em">
                                        </b-form-checkbox-group>
                                    </b-input-group>
                                    <b-input-group>
                                        <b-form-input v-model="mobile" :debounce="travellerprofiles.debounce"
                                            placeholder="Phone" trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!mobile"
                                                @click="mobile = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Country Code" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="iso_country" :debounce="travellerprofiles.debounce"
                                            placeholder="Country Code"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!iso_country"
                                                @click="iso_country = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Feed" label-for="feed" label-cols="12">
                                    <treeselect instanceId="feed" type="text" v-model="feed" :clearable="true"
                                        :multiple="true" :options="feed_options"></treeselect>
                                </b-form-group>
                            </b-col>

                        </b-row>
                    </b-card-body>
                </b-card>
                <div class="px-3">
                    <d-table classdivtable="availtable datatable" refid="travellerprofiles"
                        :icon="travellerprofiles.icon" :busy="travellerprofiles.busy"
                        :toolbarlibrary="travellerprofiles.toolbarlibrary" :tools="travellerprofiles.tools"
                        :badges="travellerprofiles.badges" :fields="travellerprofiles.fields"
                        :items="travellerprofiles.items" :limit="travellerprofiles.limit"
                        :downloaded="travellerprofiles.downloaded" :showpages="true" :offset="travellerprofiles.offset"
                        :page="travellerprofiles.page" @load="travellerprofiles_load" @click="travellerprofiles_click"
                        @changed="travellerprofiles_click('save', $event)" @select="travellerprofiles_select">
                    </d-table>
                </div>
            </div>

            <div v-show="component">
                <component :is="component" :selection="travellerprofiles.selected" :config="cconfig"
                    @discard="travellerprofiles_click('discard')" @go="travellerprofiles_click('go')"></component>
            </div>
            <b-card-footer class="mt-2 ml-1">
                <div class="text-center">
                    <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
                        <i class="fa fa-cogs mr-2"></i>Setup All
                    </b-button>
                </div>
            </b-card-footer>

        </b-card>

    </div>
</template>


<script>
import gql from "graphql-tag";

import TravellerProfileEdit from "./Components/Setup_TravellerProfileEdit";

export default {
    name: "TravellerProfiles",
    components: { TravellerProfileEdit },
    watch: {
        async slac() {
            await this.travellerprofiles_load(0);
        },
        async email() {
            await this.travellerprofiles_load(0);
        },
        async emailempty() {
            await this.travellerprofiles_load(0);
        },
        async mobile() {
            await this.travellerprofiles_load(0);
        },
        async mobileempty() {
            await this.travellerprofiles_load(0);
        },
        async iso_country() {
            await this.travellerprofiles_load(0);
        },
        async traveller() {
            await this.travellerprofiles_load(0);
        },
        async employeeno() {
            await this.travellerprofiles_load(0);
        },
        async feed() {
            await this.travellerprofiles_load(0);
        },
    },
    data() {
        return {
            traveller: [],
            slac: [],
            email: null,
            emailempty: null,
            options_emailempty: [
                { id: "", label: "Default" },
                { id: "true", label: "No" },
                { id: "false", label: "Yes" },
            ],
            mobile: null,
            mobileempty: null,
            options_mobileempty: [
                { id: "", label: "Default" },
                { id: "true", label: "No" },
                { id: "false", label: "Yes" },
            ],
            iso_country: null,
            employeeno: null,
            feed: [],
            feed_options: [
                { id: "ISOS", label: "ISOS" },
                { id: "ANVIL", label: "ANVIL" },
            ],
            travellerprofiles: {
                title: "Feed Traveller Profiles",
                icon: "fa fa-list",
                debounce: 500,
                busy: false,
                page: 1,
                offset: 0,
                limit: 15,
                tools: "go,filter,download,clipboard,add,edit,notes,deleteconfirm",
                toolbarlibrary: [],
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                    },
                    {
                        key: "traveller",
                        label: "Traveller",
                        sortable: true,
                        class: "uppercase"
                    },
                    {
                        key: "employeeno",
                        label: "EmployeeNo",
                        sortable: true,
                        class: "uppercase"
                    },
                    {
                        key: "email",
                        label: "Email",
                        sortable: true,
                        class: "uppercase"
                    },
                    {
                        key: "mobile",
                        label: "Phone",
                        sortable: true,
                        class: "uppercase"
                    },
                    {
                        key: "iso_country",
                        label: "Country",
                        sortable: true,
                        class: "uppercase"
                    },
                    {
                        key: "feed",
                        label: "Feed",
                        sortable: true,
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },

                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-100px",
                    },
                ],
                badges: [
                    {
                        key: "feed",
                        type: "badge",
                        ANVIL: "info",
                        ISOS: "danger",
                    },
                ],
                items: [],
                selected: [],
                downloaded: [],
                denied: [],
            },
        };
    },
    async mounted() {
        this.accessdenied();
        await this.travellerprofiles_load();
    },

    methods: {
        accessdenied() {
            this.travellerprofiles.denied = [];
            if (!this.user.permissions.includes("setup_travellerprofiles.admin")) {
                this.travellerprofiles.denied.push("deleteconfirm");
            }
            if (!this.user.permissions.includes("setup_travellerprofiles.admin")) {
                this.travellerprofiles.denied.push("add");
                this.travellerprofiles.denied.push("save");
            }

        },

        async travellerprofiles_load(offset, limit, page) {
            let state = this.travellerprofiles;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,
                feed: this.feed.length > 0 ? this.feed.join(",") : null,
                slac: this.slac.length > 0 ? this.slac.join(",") : null,
                traveller: this.traveller.length > 0 ? this.traveller.join(",") : null,
                email: this.email,
                emailempty: this.emailempty,
                mobile: this.mobile,
                mobileempty: this.mobileempty,
                iso_country: this.iso_country,
                employeeno: this.employeeno,
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
              query setup_travellerprofiles(
                $limit: Int
                $offset: Int
                $feed: String
                $slac: String
                $email: String
                $emailempty: String
                $mobile: String
                $mobileempty: String
                $iso_country: String  
                $traveller: String
                $employeeno: String
              ) {
                setup_travellerprofiles(
                  limit: $limit
                  offset: $offset
                  feed: $feed
                  slac: $slac
                  email: $email
                  emailempty: $emailempty
                  mobile: $mobile
                  mobileempty: $mobileempty
                  iso_country: $iso_country 
                  traveller: $traveller
                  employeeno: $employeeno
                ) {
                  id
                  slac
                  feed
                  traveller
                  dob 
                  employeeno
                  email                  
                  mobile
                  iso_country
                  notes
                  data                 
                  rows
                  updated_at
                  updated_by
                }
              }
            `,
                    variables,
                });

                // USE LOCAL VARIABLE

                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.setup_travellerprofiles
                } else {
                    state.items = response.data.setup_travellerprofiles;
                }

            } catch (error) {
                console.log(error);
            }

            state.busy = false;
        },
        async travellerprofiles_click(a, ss) {

            let state = this.travellerprofiles;

            switch (a) {
                case "download_view":
                    state.downloaded = []
                    state.downloaded = state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.travellerprofiles_load(0, 0);
                    break;

                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                    this.component = null;
                    await this.travellerprofiles_load();
                    break;
                case "go":
                    this.component = null;
                    await this.travellerprofiles_load();
                    break;
                case "add":
                case "edit":
                    this.component = "TravellerProfileEdit";
                    break;

                case "save":
                    this.saveit(ss);
                    break;

                case "delete":
                    this.deleteit(ss);
                    break;
            }
        },
        async travellerprofiles_select(ss, tools) {

            let state = this.travellerprofiles;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "add", "download", "clipboard"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "notes"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },

        async saveit(ss) {
            // let requirement = { ...this.requirement_bookerinitial };


            // let requirements = "";
            // for (var prop in requirement) {
            //   if (this.item[prop] == null) {
            //     requirements += requirement[prop] + ", ";
            //     // break;
            //   }
            // }
            // if (requirements.length > 0) {
            //   this.message =
            //     "<span class='text-danger'>" +
            //     requirements.slice(0, -1) +
            //     " required field(s). </span>";
            //   return;
            // }
            this.busy = true;

            let variables = { rows: this.cleanit(ss) };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation setup_travellerprofiles_save(
                $rows: [setup_travellerprofiles_input]
                $dateformat: String
              ) {
                setup_travellerprofiles_save(rows: $rows, dateformat: $dateformat) {
                  id
                  slac
                  feed
                  traveller
                  dob
                  email
                  mobile
                  employeeno
                  iso_country
                  notes
                  data
                }
              }
            `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
        async deleteit(ss) {

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation setup_travellerprofiles_delete(
                $rows: [setup_travellerprofiles_input]
              ) {
                setup_travellerprofiles_delete(rows: $rows) {
                  id
                }
              }
            `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.travellerprofiles_load(0);
        },
    },
};
</script>

<style></style>